import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ThinArrowDownwardIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.6 13.6L12 19.2M12 19.2V4.8M12 19.2L18.4 13.6" stroke="currentColor" strokeWidth="1.5"/>
    </svg>

)
const ThinArrowDownwardIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ThinArrowDownwardIconSvg}
    </SvgIcon>
);
export default ThinArrowDownwardIcon